<template>
  <div class="'page_set">
    <el-collapse v-model="activeNames">
      <el-collapse-item v-if="request_prefix !== 'appStage'" title="尺寸" name="1">
        <div class="content-item mb16">
          <div>
            <span class="fs14 mr8 thirdTextColor">画布比例:</span>
            <el-dropdown trigger="click" class="edit-size-list-dropdown" @command="handleCommand">
              <span class="el-dropdown-link colfff8">
                {{ sizeTypeObj.proportion }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="edit-size-list">
                <el-dropdown-item
                  v-for="(size, sizeIndex) in pageSizeList"
                  :key="sizeIndex"
                  :command="sizeIndex"
                  :class="size.type == sizeTypeObj.type ? 'active' : ''"
                >
                  <span class="fs15 colfff6">{{ size.proportion }}</span>
                  <span v-if="size.type !== 4" class="floatRight fs13 colfff4">{{ size.width }}*{{ size.height }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <double-input
          class="mt16"
          title="尺寸"
          placeHolderText="必填"
          :value1.sync="width"
          :value2.sync="height"
          inputSuffixs="px"
        />
      </el-collapse-item>
      <!--      <el-collapse-item title="背景设置" name="2" v-if="pageOption.layoutOption">-->
      <el-collapse-item title="外观" name="2" v-if="isLayout">
        <slider-and-input class="mb8" :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
        <cx-background :background.sync="background" imgType="11"></cx-background>
      </el-collapse-item>
      <el-collapse-item v-if="request_prefix !== 'appStage' && !isLayout" title="布局" name="3">
        <cx-check-box :value.sync="stageType"
          >开启布局模式<el-tooltip
            class="item"
            popper-class="cx_tips"
            effect="dark"
            content="关闭或切换布局，会影响当前页面内容模块。"
            placement="bottom"
          >
            <span class="layout_info icon-portal-info2"></span>
          </el-tooltip>
        </cx-check-box>
        <ul v-show="stageType" class="bar-styles flex mt16">
          <li
            class="bar-style-item"
            @click="changeLayout(layout.value)"
            :class="activeLayout === layout.value ? 'active' : ''"
            v-for="layout in layouts"
            :key="layout.label"
          >
            <img class="chart_style_img_box" :src="layout.src" alt="" />
            <p class="style_title">{{ layout.label }}</p>
          </li>
        </ul>
        <!-- <el-tree :data="treeData" :props="defaultProps" @node-click="handleNodeClick"></el-tree> -->
      </el-collapse-item>
      <el-collapse-item title="主题色" name="4">
        <div class="verticallyCenter">
          <span class="mr8 fs14">主题色</span>
          <div class="color-picker-container flex1">
            <el-color-picker
              class=""
              v-model="themeColor"
              color-format="rgb"
              :show-alpha="true"
              :predefine="predefineColors"
            ></el-color-picker>
            <span class="floatLeft color-text mr8">{{ themeColor }}</span>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="动态参数" name="6">
        <div class="verticallyCenter">
          <cx-check-box :value.sync="isFilterByUid">用户id</cx-check-box>
        </div>
        <div class="verticallyCenter">
          <cx-check-box :value.sync="isFilterByFid">单位id</cx-check-box>
        </div>
      </el-collapse-item>
      <el-collapse-item v-if="$store.state.states.showPluginSetting" title="插件" name="5">
        <div>
          <div class="right_font"><span @click="addPlugin" class="icon-portal-plus-small plugin_title"></span></div>
          <div v-for="(item, index) in pluginName" :key="index" class="mt8 plugins">
            <span class="plugin_title mr8">插件名</span>
            <el-input
              class="mr16"
              style="width: 168px"
              :value="item"
              @input="changePluginName(index, $event)"
              placeholder="请输入插件名"
            ></el-input>
            <span @click="delPlugin(index)" class="plugin_title icon-portal-delete"></span>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="页面刷新" name="7">
        <cx-check-box :value.sync="openPageRefresh">开启页面刷新</cx-check-box>
        <div class="card mt8" v-show="openPageRefresh">
          <cx-slider
            label="方式"
            :value.sync="refreshType"
            :options="refreshTypeList"
          />
          <div v-if="refreshType === 'timing'" class="fresh-setting mt8 verticallyCenter">
            <span class="mr8">每天</span>
            <div class="verticallyCenter">
              <el-select class="width70" v-model="refreshHours" placeholder="时">
                <el-option v-for="(item, index) in 24" :key="index" :label="index" :value="index">
                </el-option>
              </el-select>
              <span class="marginLeftRight">:</span>
              <el-select class="width70" v-model="refreshMinutes" placeholder="分">
                <el-option v-for="item in 59" :key="item" :label="item" :value="item">
                </el-option>
              </el-select>
            </div>
          </div>
          <div v-if="refreshType === 'interval'" class="fresh-setting mt8">
            <span>每隔</span>
            <single-input
              class="mr16"
              style="width: 80px; margin-left: 8px; margin-right: 8px"
              :value.sync="updateTimer"
              :min="1"
              :max="999"
              :noInputSuffixs="true"
            />
            <span>时刷新一次</span>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { initStageLayout, startCreateLayoutStage } from "utils/stageLayout"
import layout1 from "assets/images/stage_layout1.png"
import layout2 from "assets/images/stage_layout2.png"
import layout3 from "assets/images/stage_layout3.png"
import layout4 from "assets/images/stage_layout4.png"
import layout5 from "assets/images/stage_layout5.png"
import layout6 from "assets/images/stage_layout6.png"
import layout7 from "assets/images/stage_layout7.png"
export default {
  data() {
    return {
      treeData: [],
      defaultProps: {
        children: "children",
        label: "label"
      },
      data: [
        {
          label: "一级 1",
          children: [
            {
              label: "二级 1-1",
              children: [
                {
                  label: "三级 1-1-1"
                }
              ]
            }
          ]
        },
        {
          label: "一级 2",
          children: [
            {
              label: "二级 2-1",
              children: [
                {
                  label: "三级 2-1-1"
                }
              ]
            },
            {
              label: "二级 2-2",
              children: [
                {
                  label: "三级 2-2-1"
                }
              ]
            }
          ]
        },
        {
          label: "一级 3",
          children: [
            {
              label: "二级 3-1",
              children: [
                {
                  label: "三级 3-1-1"
                }
              ]
            },
            {
              label: "二级 3-2",
              children: [
                {
                  label: "三级 3-2-1"
                }
              ]
            }
          ]
        }
      ],
      layouts: [
        {
          value: "layout1",
          label: "布局1",
          src: layout1
        },
        {
          value: "layout2",
          label: "布局2",
          src: layout2
        },
        {
          value: "layout3",
          label: "布局3",
          src: layout3
        },
        {
          value: "layout4",
          label: "布局4",
          src: layout4
        },
        {
          value: "layout5",
          label: "布局5",
          src: layout5
        },
        {
          value: "layout6",
          label: "布局6",
          src: layout6
        },
        {
          value: "layout7",
          label: "布局7",
          src: layout7
        }
      ],
      activeLayout: undefined,
      activeNames: ["1", "2", "3", "4", "7"],
      tabsActive: 0, //  显示背景还是背景图片

      pageSizeList: [
        {
          type: 0,
          width: 1920,
          height: 1080,
          proportion: "16:9"
        },
        {
          type: 1,
          width: 1920,
          height: 1440,
          proportion: "4:3"
        },
        {
          type: 2,
          width: 1080,
          height: 1920,
          proportion: "9:16"
        },
        {
          type: 3,
          proportion: "自定义"
        }
      ],
      sizeTypeObj: {
        type: 3,
        proportion: "自定义"
      },
      pageSizeNames: {
        pageWidth: "height",
        height: "pageWidth"
      },
      containerSizeNames: {
        width: "height",
        height: "width"
      },
      predefineColors: [
        "#0047FF",
        "#00E4E4",
        "#FFA63F",
        "#D627B0",
        "#C035E3",
        "#802CF5",
        "#8BFF4A",
        "#FFA429",
        "#FF5C5A",
        "#FF58C7",
        "#53FFAC",
        "#FFF91F",
        "#41FFD1",
        "#6D5CFF",
        "#0089FF",
        "#FF6969",
        "#83FF7D",
        "#4EDBFF",
        "#E3FF59",
        "#B700FF"
      ],
      refreshTypeList: [
        {
          value: "timing",
          title: "定时刷新"
        },
        {
          value: "interval",
          title: "间隔刷新"
        }
      ],
    }
  },
  computed: {
    stageType: {
      get() {
        if (this.pageOption.stageType === undefined || this.pageOption.stageType === "position") {
          return false
        } else return true
      },
      set(val) {
        this.$confirm("切换布局模式会导致页面内容整体丢失, 是否继续?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          showClose: false,
          iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
          cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
          confirmButtonClass: `${this.request_prefix}_confirm_button`,
          customClass: `${this.request_prefix}_confirm custom_warning_dialog`
        })
          .then(() => {
            //开启或者关闭布局时需要清空当前页面的事件
            this.$event.clearAllEvents()
            initStageLayout.call(this, val)
            if (val) {
              this.$changePageAttribute({ option_name: "stageType", option_val: "layOut" }, true)
            } else {
              this.$changePageAttribute({ option_name: "stageType", option_val: "position" }, true)
            }
            this.$store.dispatch(this.request_prefix + "/clearAllRect")
            this.$message({
              type: "success",
              message: "切换成功!"
            })
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消切换"
            })
          })
      }
    },
    isLayout() {
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    ids() {
      return this.$store.state.states.activeID
    },
    pageOption() {
      return this.$store.state[this.request_prefix].page
    },
    pluginName: {
      get() {
        return this.checkAndSetPrimaryVal(this.pageOption, "pluginName", "pluginName", [])
      },
      set(val) {
        this.$changePageAttribute({ option_name: "pluginName", option_val: val })
      }
    },
    width: {
      get() {
        if (this.pageOption.stageType === "layOut") {
          return this.pageOption.pageWidth
        } else {
          return this.$store.state[this.request_prefix].page.children[0].width
        }
      },
      set(val) {
        this.setSizeByStageType("pageWidth", "height", val)
      }
    },
    height: {
      get() {
        if (this.pageOption.stageType === "layOut") {
          return this.pageOption.height
        } else {
          return this.$store.state[this.request_prefix].page.children[0].height
        }
      },
      set(val) {
        this.setSizeByStageType("height", "height", val)
      }
    },
    opacity: {
      get() {
        return this.$store.state[this.request_prefix].page.children[0].options.opacity || 100
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false, "", {
          container_id: this.$store.state[this.request_prefix].page.children[0].container_id
        })
      }
    },
    background: {
      get() {
        let background = this.$store.state[this.request_prefix].page.children[0].options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = []
        if (this.backgroundImage) {
          newBackground.push({
            type: "img",
            label: "图片",
            imgUrl: this.backgroundImage,
            clipSize: this.clipSize,
            repeatType: this.repeatType,
            alignType: this.alignType,
            opacity: 100
          })
        }
        if (this.bgColorType === "线性渐变") {
          newBackground.push({
            type: "linearGradient",
            label: "线性渐变",
            data: {
              angle: this.bgColorlinearGradientAngle,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        if (this.bgColorType === "径向渐变") {
          newBackground.push({
            type: "radialGradient",
            label: "径向渐变",
            data: {
              siteX: 50,
              siteY: 50,
              stops: [
                [this.bgStartColor, 0],
                [this.bgEndColor, 1]
              ]
            }
          })
        }
        newBackground.push({
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: this.bgColorType === "纯色" ? this.bgColor : "rgba(0,0,0,0)"
        })
        this.$changeOptionsEV(newBackground, "background", false, "", {
          container_id: this.$store.state[this.request_prefix].page.children[0].container_id
        })
        return newBackground
      },
      set(val) {
        this.$changeOptionsEV(val, "background", false, "", {
          container_id: this.$store.state[this.request_prefix].page.children[0].container_id
        })
      }
    },
    themeColor: {
      get() {
        let flag = this.$store.state[this.request_prefix].page.themeColor
        if (typeof flag === "undefined") {
          flag = "#3D82F2"
          this.$changePageAttribute({ option_name: "themeColor", option_val: flag }, true)
        }
        return flag
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "themeColor", option_val: newVal })
      }
    },
    // 是否根据uid筛选数据
    isFilterByUid: {
      get() {
        return this.$store.state[this.request_prefix].page.isFilterByUid || false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "isFilterByUid", option_val: newVal })
      }
    },
    // 是否根据fid筛选数据
    isFilterByFid: {
      get() {
        return this.$store.state[this.request_prefix].page.isFilterByFid || false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "isFilterByFid", option_val: newVal })
      }
    },
    openPageRefresh: {
      get() {
        return this.pageOption.openPageRefresh || false
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "openPageRefresh", option_val: newVal }, true)
      }
    },
    refreshType: {
      get() {
        return this.pageOption.refreshType || "interval"
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "refreshType", option_val: newVal }, true)
      }
    },
    updateTimer: {
      get() {
        return this.pageOption.updateTimer || 1
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "updateTimer", option_val: newVal }, true)
      }
    },
    refreshHours: {
      get() {
        return this.pageOption.refreshHours
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "refreshHours", option_val: newVal }, true)
      }
    },
    refreshMinutes: {
      get() {
        return this.pageOption.refreshMinutes
      },
      set(newVal) {
        this.$changePageAttribute({ option_name: "refreshMinutes", option_val: newVal }, true)
      }
    }
  },
  methods: {
    changePluginName(index, name) {
      this.$changePageAttribute({ option_name: "pluginName." + index, option_val: name })
    },
    delPlugin(index) {
      const pluginName = [...this.pluginName]
      pluginName.splice(index, 1)
      this.$changePageAttribute({ option_name: "pluginName", option_val: pluginName })
    },
    addPlugin() {
      this.$changePageAttribute({ option_name: "pluginName." + this.pluginName.length, option_val: "" })
    },
    handleNodeClick() {
      console.log(arguments)
    },
    changeLayout(layout) {
      this.$confirm("切换布局模式会导致页面内容整体丢失, 是否继续?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          this.activeLayout = layout
          startCreateLayoutStage.call(this, layout)
          //切换布局时需要清空当前页面的事件
          this.$event.clearAllEvents()
          this.$store.dispatch(this.request_prefix + "/clearAllRect")
          this.$message({
            type: "success",
            message: "切换成功!"
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消切换"
          })
        })
    },
    changeActiveHandle(event, flag) {
      event.stopPropagation()
      this.tabsActive = flag
    },
    setSizeByStageType(k1, k2, val) {
      if (this.pageOption.stageType === "layOut") {
        this.$changePageAttribute({ option_name: k1, option_val: val })
        if (this.sizeTypeObj.type !== 3) {
          //根据比例修改另一个值
          this.$changePageAttribute({
            option_name: this.pageSizeNames[k1],
            option_val: this.fixFalue(this.pageSizeNames[k1], val)
          })
        }
      } else {
        this.$store.dispatch(this.request_prefix + "/changeContainerAttribute", {
          key: k1 === "pageWidth" ? "width" : k1,
          data: val,
          containerId: this.ids.container_id
        })
        if (this.sizeTypeObj.type !== 3) {
          this.$store.dispatch(this.request_prefix + "/changeContainerAttribute", {
            key: this.containerSizeNames[k2],
            data: this.fixFalue(this.containerSizeNames[k2], val),
            containerId: this.ids.container_id
          })
        }
      }
    },
    fixFalue(name, value) {
      let key = name === "pageWidth" ? "width" : name
      let from = key === "width" ? 0 : 1 //宽还是高
      let res = key === "width" ? 1 : 0 //宽还是高
      const caculateNum = this.pageSizeList[this.sizeTypeObj.type].proportion.split(":").map(it => Number(it))
      console.log((Number(value) / caculateNum[res]) * caculateNum[from])
      return Number(((Number(value) / caculateNum[res]) * caculateNum[from]).toFixed(0))
    },
    handleCommand(command) {
      this.sizeTypeObj = this.pageSizeList[command]
      if (command !== 3) {
        this.width = this.pageSizeList[command].width
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page_set {
  padding: 16px 24px;
}
.edit-size-list-dropdown {
  width: calc(100% - 70px);
}
.edit-size-list {
  width: 252px;
  /*background: var(--themeColor);*/
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.edit-size-list-dropdown {
  width: calc(100% - 70px);
}
.bar-styles {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.bar-style-item {
  position: relative;
  display: inline-block;
  width: calc((100% - 32px) / 3);
  margin-right: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
  cursor: pointer;
  &:nth-child(3n) {
    margin-right: 0;
  }
  .chart_style_img_box {
    width: 100%;
    height: 52px;
    border: 1px solid;
    box-sizing: content-box;
    border-color: transparent;
    border-radius: 4px;
    box-sizing: border-box;
    .chart_style_img {
      width: 100%;
      height: 100%;
    }
  }
  &:hover {
    .chart_style_img_box {
      border-color: rgba(23, 112, 255, 0.3);
    }
  }
  &.active {
    .chart_style_img_box {
      border-color: var(--themeColor);
    }
    .style_title {
      color: rgba(255, 255, 255, 0.8);
    }
  }
}
.style_title {
  margin-top: 6px;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
}
.bar-style-item:last-child {
  margin-right: 0px;
}
.thirdTextColor {
  color: var(--thirdTextColor);
}
.el-checkbox__inner {
  width: 14px;
  height: 14px;
}
.font-arrangement-btn .btn-active {
  width: calc((100% - 6px) / 2);
}
.marginLeftRight {
  margin: 0 8px;
}
.width70 {
  width: 70px;
}
</style>
